import type { FC } from "react";

import { TerminalBatchUpdateModal } from "src/app/features/Terminal/components/buttons/TerminalBatchUpdateModal";
import { TerminalDeleteButton } from "src/app/features/Terminal/components/buttons/TerminalDeleteButton";
import { TerminalSearchForm } from "src/app/features/Terminal/components/forms/TerminalsSearchForm";
import { TerminalsTable } from "src/app/features/Terminal/components/tables/TerminalsTable";
import type { TerminalList } from "src/app/features/Terminal/types/TerminalList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { Permissions } from "../../../../core/router/config/Permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";
import { TerminalBatchAddButton } from "../components/buttons/TerminalBatchAddButton";

export const TerminalsPage: FC<NoneOwnProps> = () => {
    const table = <TerminalsTable />;
    const searchForm = <TerminalSearchForm />;
    const hasAccess = canAccess(ResourceName.TERMINALS, "canRead");

    return (
        <PageLayout name="terminals_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.terminals" />
                    <ResourceManager<TerminalList>
                        useDataGroup
                        dataMapperKey="terminalTableData"
                        resource={ResourceName.TERMINALS}
                        table={table}
                        searchForm={searchForm}
                        customActions={[
                            {
                                action: <TerminalDeleteButton />,
                                permission: Permissions.DELETE,
                            },
                            {
                                action: <TerminalBatchUpdateModal />,
                                permission: "batchUpdateCsv",
                            },
                            {
                                action: <TerminalBatchAddButton />,
                                permission: "batchAdd",
                            },
                        ]}
                        actions={[Actions.ADD, Actions.FORM_COPY, Actions.EXPORT, Actions.IMPORT_DATA]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
